export default "__VITE_ASSET__CRz32ASf__"